import React from 'react'
import './ShoppingCart.css'
import WorkDescription from './WorkDescription'
import pic1 from '../vendor/full5.png'
import pic2 from '../vendor/nav.png'
import pic3 from '../vendor/cartlaptop2.png'
import pic4 from '../vendor/cartlaptop.png'
import pic5 from '../vendor/cart phone.png'
import { useEffect } from 'react'

function ShoppingCart() {

    useEffect(() => {
        document.title = "Shopping Cart / Harshita Singh — Design & Development"
    }, []);

    return (
        <div className="cart">
            <div className="cart__cols">
                <div className="cart__left">
                    <hr className="cart__hr" />
                    <img className="cart__img" src={pic1} />
                    <img className="cart__img" src={pic2} />
                    <img className="cart__img cart__mockups" src={pic3} />
                    <img className="cart__img cart__mockups" src={pic4} />
                    <img className="cart__img cart__mockups" src={pic5} />
                </div>
                <WorkDescription title="Shopping Cart" subtitle="Web development, design" seeLive="https://shopping-cart-assignment-harshita-singh.netlify.app/" sourceCode="https://github.com/harshitaSingh11/shopping-cart" />
            </div>
        </div>
    )
}

export default ShoppingCart
